/*
 * Public API Surface of pepperi-lib/textbox-icon
 */
export * from './textbox-icon.module';
export * from './textbox-icon.component';
